const TikTokIcon = ({ color }: { color?: string }) => (
  <svg
    width="30"
    height="34"
    viewBox="0 0 30 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9411 0H16.2111V23.1594C16.2111 25.9189 14.0073 28.1855 11.2648 28.1855C8.52219 28.1855 6.31836 25.9189 6.31836 23.1594C6.31836 20.4493 8.47322 18.2318 11.1179 18.1333V12.3189C5.2899 12.4174 0.588379 17.1971 0.588379 23.1594C0.588379 29.1711 5.38784 34 11.3137 34C17.2396 34 22.039 29.1218 22.039 23.1594V11.284C24.1939 12.8609 26.8385 13.7971 29.63 13.8464V8.03189C25.3204 7.88406 21.9411 4.33623 21.9411 0Z"
      fill={color || "white"}
    />
  </svg>
);

export default TikTokIcon;
